/**
 * EDIT FEED ENTRY POINT
 *
 * This page allows the user to edit feed data, in a similar fashion to the Add RSS Feed page.
 *
 * @version 0.1
 */

import BaseFeedEditingComponent from './../BaseFeedEditingComponent/BaseFeedEditingComponent.index.jsx';

export default class AddRssFeed extends BaseFeedEditingComponent {

    componentWillMount() {
        super.componentWillMount('addRssFeed');
    }

    logFeedCreateCancel() {
    }

    render() {
        return super.render();
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/AddRssFeed/AddRssFeed.index.jsx